import { render, staticRenderFns } from "./QrScan.vue?vue&type=template&id=28056af0&scoped=true&"
import script from "./QrScan.vue?vue&type=script&lang=js&"
export * from "./QrScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28056af0",
  null
  
)

export default component.exports